import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVideo"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H16V8.78613L22 5.78613V18.2132L16 15.2132V20H2V4ZM16 13.5361L20.5 15.7861V8.21318L16 10.4632V13.5361Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo;
